/*
 * end-grids
 *
 * Look for the link with the risk class font,
 * based on that class, add the stored grid
 * to the DOM.
 *
 * Author: Tim Bauwens
 * Copyright Berkeley Bridge 2021
 */

import { getmetadata } from "$json/lib/getmetadata";

((win, doc, $) => {
  const GRID = function () {
    let grid = doc.createElement("div");
    grid.className = "insertedgrid";
    grid.insertAdjacentHTML(
      "beforeend",
      `
      <div>
        <table class="legenda">
          <tr>
            <td>
              <div class="icon_img"><img alt="" class="img_people" src="custom/rijks-ccv/plugins/end-grids/live/1.png" /></div>
              <div class="icon_expln">Advies om door onderneming zelf om uit te voeren</div>
            </td>
            <td>
              <div class="icon_img"><img alt="" class="img_people" src="custom/rijks-ccv/plugins/end-grids/live/2.png" /></div>
              <div class="icon_expln">Advies om door ondernemer en leverancier samen uit te voeren</div>
            </td>
            <td>
              <div class="icon_img"><img alt="" class="img_people" src="custom/rijks-ccv/plugins/end-grids/live/3.png" /></div>
              <div class="icon_expln">Advies om door leverancier uit te voeren</div>
            </td>
          </tr>
        </table>
      </div>
    `
    );
    return grid;
  };

  $(doc).on("bb:finalHandleData", (e, data) => {
    if (data && data.groups && data.groups.length) {
      doc.querySelectorAll(".disposable").forEach(el => el.remove());
      // If the metadata flag to show is there, make the grid and download buttons.
      const props = getmetadata(data).props;
      if (props.has("p-end-grids")) {
        try {
          doc
            .querySelector("#bb-q .bbm-end-text")
            .insertAdjacentElement("beforebegin", GRID());
        } catch (err) {
          win.console && win.console.warn(err);
        }
      }
    }
  });
})(window, document, jQuery);
